/**
 * Display a checkmark icon if the value is true, otherwise display nothing
 */
export const displayCheckmarkCellRenderer = (params) => {
    if (params.value) return '<span><i class="fa fa-check"></i></span>'
    else return ''
}